import Swal from "sweetalert2"
import Configs, { axiosbaseurl } from "../config"

export const fetchData = async (toggleLoading, apiName) => {
  try {
    toggleLoading(true)
    const res = await axiosbaseurl.get(`/${apiName}`)
    toggleLoading(false)
    return res.data
  } catch (error) {
    console.error(error)
    if (error?.response?.status === 401) {
      const isLoginPage = window.location.pathname.includes("/login")
      if (!isLoginPage) {
        Swal.fire({
          title: "Session Expired",
          text: "Please Login Again",
          icon: "warning",
          confirmButtonText: "OK",
        }).then(() => {
          window.location.href = `${Configs.appurl}login`
        })
      }
    }
    toggleLoading(false)
  }
}

export const FetchPostData = async (
  toggleLoading,
  apiName,
  formDataEntries = {}
) => {
  try {
    toggleLoading(true)
    const formData = new FormData()
    for (const [key, value] of Object.entries(formDataEntries)) {
      formData.append(key, value)
    }
    // Check if any value is a File or Blob
    const hasFile = Object.values(formDataEntries).some(
      value => value instanceof File || value instanceof Blob
    )

    let res

    if (hasFile) {
      // Build FormData
      const formData = new FormData()
      for (const [key, value] of Object.entries(formDataEntries)) {
        formData.append(key, value)
      }

      res = await axiosbaseurl.post(`${apiName}`, formData, {
        headers: {
          // Let browser set multipart/form-data boundary
          "Content-Type": "multipart/form-data",
        },
      })
    } else {
      // Send JSON directly
      res = await axiosbaseurl.post(`${apiName}`, formDataEntries, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    }
    toggleLoading(false)
    return res
  } catch (error) {
    toggleLoading(false)
    return error
  }
}

export const FetchPutData = async (
  toggleLoading,
  nodeUrl,
  id,
  formDataEntries = {}
) => {
  try {
    toggleLoading(true)

    // Check if any value is a File or Blob
    const hasFile = Object.values(formDataEntries).some(
      value => value instanceof File || value instanceof Blob
    )

    let res

    if (hasFile) {
      // Build FormData
      const formData = new FormData()
      for (const [key, value] of Object.entries(formDataEntries)) {
        formData.append(key, value)
      }

      res = await axiosbaseurl.put(`/${nodeUrl}/${id}`, formData, {
        headers: {
          // Let browser set multipart/form-data boundary
          "Content-Type": "multipart/form-data",
        },
      })
    } else {
      // Send JSON directly
      res = await axiosbaseurl.put(`/${nodeUrl}/${id}`, formDataEntries, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    }

    toggleLoading(false)
    return res
  } catch (error) {
    console.error(error)
    toggleLoading(false)
    return error
  }
}

// DELETE - Remove
export const FetchDeleteData = async (toggleLoading, nodeUrl, id) => {
  try {
    toggleLoading(true)
    const res = await axiosbaseurl.delete(`/${nodeUrl}/${id}`)
    toggleLoading(false)
    return res
  } catch (error) {
    console.error(error)
    toggleLoading(false)
    return error
  }
}
